import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../../service/locale/TranslationService";
import ReportingPeriodApplicantDocumentForm from "./ReportingPeriodApplicantDocumentForm";
import { IReportingPeriodApplicantDocument } from "../../../../model/document/ReportingPeriodApplicantDocument";

export interface State {}

export interface UpdateReportingPeriodApplicantDocumentFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IReportingPeriodApplicantDocument;
  codebooks?: any;
}

class UpdateReportingPeriodApplicantDocumentForm extends React.Component<
  UpdateReportingPeriodApplicantDocumentFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler((e) => {
      e.preventDefault();
      const { rowData } = this.props;
      let newFormVersionDocument;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormVersionDocument = { ...rowData, ...values };
          newFormVersionDocument.document =
            values.document[0] && values.document[0].originFileObj;
        }
      });
      return newFormVersionDocument;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ReportingPeriodApplicantDocumentForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        formVersionDocument={rowData}
        allowedFileTypes={codebooks?.allowedFileTypes}
      />
    );
  }
}

export default UpdateReportingPeriodApplicantDocumentForm;
